export const ONE_STAR_RATING = 'one';
export const TWO_STAR_RATING = 'two';
export const THREE_STAR_RATING = 'three';
export const FOUR_STAR_RATING = 'four';
export const FIVE_STAR_RATING = 'five';

export const STAR_RATINGS = [
  ONE_STAR_RATING,
  TWO_STAR_RATING,
  THREE_STAR_RATING,
  FOUR_STAR_RATING,
  FIVE_STAR_RATING,
];
